import React from 'react';
import { useSelector } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import ZenDaiUniIcon from '../../../../../../../assets/images/ZEN_WBTC.svg';
import Confirm from '../../../../../../../components/Stake/frame/confirm';
import { toPowerOfZen } from '../../../../../../../blockchain/config';

const UnstakeConfirm = () => {
  const { amount } = useSelector((state) => state.ZENWBTCUNIstake.stake);

  const unstakingToken = `${amount / toPowerOfZen} zenWBTC`;

  return (
    <>
      <Header icon={ZenDaiUniIcon} title='zenWBTC-Unstaking' />
      <Confirm title='You Are Unstaking:' token={unstakingToken} />
    </>
  );
};

export default UnstakeConfirm;
